




























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';

import { UsersList } from '@/common/Users';

// Services
import * as Sentry from '@sentry/browser';
import Staff from '@/services/Staff';
import Auth from '@/services/Auth';

// Components
import Welcome from '@/components/Global/Welcome.vue';
import Loading from '@/components/Global/Loading.vue';
import Alert from '@/components/Global/Alert.vue';
import UserManagementSwitch from '@/components/Staff/UserManagement/Switch.vue';
import TextField from '@/components/Form/TextField.vue';
import SelectField from '@/components/Form/SelectField.vue';

@Component({
	name: 'StaffUserManagement',
	components: {
		Welcome,
		Loading,
		Alert,
		UserManagementSwitch,
		TextField,
		SelectField,
	},
})
export default class UserManagement extends Vue {
	@State('incompleteUsers', { namespace: 'Users' }) private users: UsersList[];
	private updatedUsers: UsersList[] = [];
	private searchText: string = '';
	private filterSearchType: string = 'Email';
	private statusType: string = '';
	private paginate: string[] = ['updatedUsers'];
	private error: boolean = false;
	private error2: boolean = false;
	private loading: boolean = true;
	private Auth: any = Auth;
	private success: boolean = false;

	@Watch('users', { deep: true })
	private watchUsers() {
		if (this.users.length > 0) {
			this.updatedUsers = this.users;
		}
	}

	private search() {
		this.updatedUsers = this.users;
		this.searchText = this.searchText.toLowerCase();

		if (this.filterSearchType === 'Email' && this.searchText) {
			const regex = new RegExp(this.searchText, 'g');
			const filteredUsers = this.users
				.map(user => {
					if (user.email !== undefined) {
						if (user.email.match(regex)) {
							return user;
						}
					}
				})
				.filter(user => {
					if (user !== undefined) {
						return user;
					}
				});

			this.updatedUsers = filteredUsers;
		} else if (this.filterSearchType === 'Status' && this.statusType) {
			// tslint:disable-next-line: prefer-const
			let filteredUser = [];
			const status = this.statusType;
			this.users.forEach(user => {
				if (
					(user.Enabled && status === 'Enabled') ||
					(!user.Enabled && status === 'Disabled')
				) {
					filteredUser.push(user);
				}
			});
			this.updatedUsers = filteredUser;
		} else {
			this.updatedUsers = this.users;
		}
	}

	private async deleteUser(sub, email) {
		this.success = this.error = false;
		const res = confirm(`Are you sure you want to delete the user? ${email}`);
		if (res) {
			try {
				const delRes = await Staff.deleteCognitoUser(sub);
				// console.log(`delete results: ${JSON.stringify(del_res, null, 2)}`);
				for (let i = 0; i < this.updatedUsers.length; i++) {
					if (this.updatedUsers[i].sub === sub) {
						this.updatedUsers.splice(i, 1);
					}
				}
				this.success = true;
			} catch (e) {
				this.error2 = true;
			}
		}
	}

	private changeSearchType($event) {
		this.filterSearchType = $event.target.value;
	}

	private changeStatusType($event) {
		this.statusType = $event.target.value;
	}

	private async created() {
		try {
			await this.$store.dispatch('Users/getIncompleteUsers');
		} catch (e) {
			Sentry.captureException(e);
			this.error = true;
		} finally {
			this.loading = false;
		}
	}
}
